import Stack from '@mui/material/Stack';

import { DomainServiceStatus, PackageDetailsInfo } from '../../utils/types';
import AdvancedInfo from './components/AdvancedInfo';
import SharedInfo from './components/SharedInfo';

interface PackageDetailsProps {
  details: PackageDetailsInfo;
  osTemplateValue: string;
  isAtomic?: boolean;
  isAdvanced?: boolean;
  hostingPlanId: string;
  backReference: string;
  domainServiceStatus: DomainServiceStatus;
  serverStatus: string;
  hasSitesCapability: boolean;
  accountType?: string | null;
  serverId?: string | null;
}

const PackageDetails = ({
  details,
  osTemplateValue,
  isAtomic = false,
  isAdvanced = false,
  hostingPlanId,
  backReference,
  domainServiceStatus,
  serverStatus,
  hasSitesCapability,
  accountType = null,
  serverId = null,
}: PackageDetailsProps) => (
  <Stack pb={3} pt={isAdvanced ? 0 : 2}>
    {isAdvanced && (
      <AdvancedInfo
        details={details}
        hostingPlanId={hostingPlanId ?? ''}
        osTemplateValue={osTemplateValue}
        domainServiceStatus={domainServiceStatus}
        serverStatus={serverStatus}
        hasSitesCapability={hasSitesCapability}
        accountType={accountType}
        serverId={serverId}
      />
    )}
    {!isAtomic && !isAdvanced && (
      <SharedInfo
        details={details}
        hostingPlanId={hostingPlanId ?? ''}
        backReference={backReference ?? ''}
      />
    )}
  </Stack>
);

export default PackageDetails;
